import React from 'react';
import { Icon } from '@cloudscape-design/components';
import { colorTextStatusError } from '@cloudscape-design/design-tokens';

interface FieldRequirementLabelProps {
  fieldName: string;
  requireOnFail?: boolean;
  requireOnPass?: boolean;
  result?: string;
}

/**
 * Renders a field label with (Required)/(Optional) suffix.
 * When the field is required for the current response result (FAIL or PASS),
 * shows the label in red with a warning icon.
 */
const FieldRequirementLabel: React.FC<FieldRequirementLabelProps> = ({
  fieldName,
  requireOnFail,
  requireOnPass,
  result,
}) => {
  const isActiveRequired =
    (!!requireOnFail && result === 'FAIL') || (!!requireOnPass && result === 'PASS');
  const suffix = isActiveRequired ? '(Required)' : '(Optional)';

  if (isActiveRequired) {
    return (
      <span style={{ color: colorTextStatusError }}>
        <Icon name="status-warning" variant="error" /> {fieldName} {suffix}
      </span>
    );
  }

  return (
    <span>
      {fieldName} {suffix}
    </span>
  );
};

export default FieldRequirementLabel;
